import "./email";
import "./min";
import "./max";
import "./hexadecimal";
import "./phone";
import "./numeric";
import "./mandatory";
import "./url";
import "./float";
import "./between";
import "./isbefore";
import "./function";
